import { TableCell } from '@/components/ui/table';
import { ComplianceStatusBadge } from '@/warranty-v3/components/compliance-status-badge';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type ComplianceStatusCellProps = {
  row: UnitOverviewRow;
};

export function ComplianceStatusCell({ row }: ComplianceStatusCellProps) {
  return (
    <TableCell narrow justify="left" className="whitespace-nowrap">
      {row.complianceStatus ? (
        <ComplianceStatusBadge status={row.complianceStatus} />
      ) : (
        '-'
      )}
    </TableCell>
  );
}
